import { useParams, useSearchParams } from "react-router-dom";

import { CustomerQuoteEditorFeaturePage } from "..";

/**
 * 对客报价编辑器路由页。
 */
export function CustomerQuotePage() {
const { customerQuoteId } = useParams<{ customerQuoteId: string }>();
  const [searchParams] = useSearchParams();
  if (!customerQuoteId) return <div role="alert">缺少报价版本标识</div>;
  const orderId = searchParams.get("orderId");
  const rosterId = searchParams.get("rosterId");
  const feeAdjustmentContext = orderId && rosterId ? { orderId, rosterId } : undefined;
  return (
    <CustomerQuoteEditorFeaturePage
      customerQuoteId={customerQuoteId}
      feeAdjustmentContext={feeAdjustmentContext}
    />
  );
}
